import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { debounce } from '../../../services/utils'
import brokerApi from '../../../api/broker.api'

const NameAutocomplete = ({ ...props }) => {
  const [names, setNames] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { selectUser } = props

  async function filter(value) {
    if (value === '') {
      setNames([])
      return
    }
    setIsLoading(true)
    const { data } = await brokerApi.searchUserByName(value)
    setNames([...data])
    setIsLoading(false)
  }

  const debounceHandler = useCallback(debounce(filter, 300), [])

  const handleFiltering = (e, newval) => {
    if (newval.length >= 3) {
      debounceHandler(newval)
    }
  }

  const handleNamePick = async (e, value) => {
    selectUser(value)
  }

  return (
    <Autocomplete
      fullwidth
      getOptionLabel={(option) => `${option.full_name} - ${option.email}`}
      loading={isLoading}
      className="margin-top-8"
      onChange={handleNamePick}
      onInputChange={handleFiltering}
      options={names}
      filterOptions={(x) => x}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth={true}
          variant="outlined"
          className="margin-top-8 margin-bottom-basic"
          placeholder="Type user's name"
        />
      )}
    />
  )
}

export default NameAutocomplete
